export const nonNumericRegex = /[^0-9.]/g;

export function parseCurrency(value: string, type: 'float' | 'int' = 'float'): number {
  const stripped = value.replaceAll(nonNumericRegex, '');
  return type === 'float' ? parseFloat(stripped) : parseInt(stripped, 10);
}
